import React from "react";
import "../../assets/css/adminStyle.css";
import Dashboard from "./Dashboard";

const index = () => {
  return (
    <section id="admin" className="relative">
      {/* <Navbar /> */}
      <Dashboard />
    </section>
  );
};

export default index;
